<div class="row action-toolbar" style="margin-top: 20px">
    <div class="col-12">
        <form class="form-inline">
            <div class="input-header-group">
                <span class="input-header">Start Year</span>
                <wj-combo-box
                    [(ngModel)]="startYear"
                    name="equipmentStartYear"
                    (ngModelChange)="onRangeChanged()"
                    [itemsSource]="yearOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    style="width: 110px"
                ></wj-combo-box>
            </div>

            <div class="input-header-group">
                <span class="input-header">End Year</span>
                <wj-combo-box
                    [(ngModel)]="endYear"
                    name="equipmentEndYear"
                    (ngModelChange)="onRangeChanged()"
                    [itemsSource]="yearOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    style="width: 110px"
                ></wj-combo-box>
            </div>

            <div class="input-header-group">
                <span class="input-header" title="Replaces the historical Fuel (300) rate. Adjusted fuel is gallons per revenue hour times this price.">Current Fuel Price ($/gal)</span>
                <wj-input-number
                    name="fuelPrice"
                    [value]="fuelPrice"
                    (valueChange)="onFuelPrice($event)"
                    [format]="'n2'"
                    [min]="0"
                    [isRequired]="false"
                    [placeholder]="'per gal'"
                    style="width: 120px"
                ></wj-input-number>
            </div>
        </form>
    </div>
</div>

@if (rangeInvalid) {
    <p class="text-danger mt-2">Start year must be on or before the end year.</p>
}
@if (loadError) {
    <p class="text-danger mt-2">{{ loadError }}</p>
}

<p class="text-muted mt-3 mb-2">
    A rate is cost divided by revenue hours, so a category rate is weighted by the hours in that category.
    Avg is that rate for the whole selected period, not an average of the yearly rates.
    @if (closedLabel) {
        Closed through {{ closedLabel }}. The current year runs through that month.
    }
</p>

<h5 class="mb-1">Rate by Category</h5>
<p class="text-muted mb-2">
    One row per equipment category for the selected period. This is not split by year and it is not grouped by the mega category.
    Enter a current fuel price to recalculate Fuel (300) and the total rate from historical gallons per hour.
</p>
<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="categoryGrid"></action-toolbar-count>
            <action-toolbar-search name="categorySearch" [(ngModel)]="categoryGrid.filter"></action-toolbar-search>
            <grid-export [grid]="categoryRateGrid" [name]="'Equipment Rates by Category'"></grid-export>

            <div class="input-header-group">
                <span class="input-header" title="Categories drawn on the trend chart. The first load selects the five categories with the most hours.">Trend Categories</span>
                <wj-multi-select
                    name="trendCategories"
                    [itemsSource]="categoryOptions"
                    [displayMemberPath]="'display'"
                    [checkedMemberPath]="'$checked'"
                    [placeholder]="'Select categories'"
                    (checkedItemsChanged)="rebuildTrend()"
                ></wj-multi-select>
            </div>
        </form>
    </div>
</div>
<wj-flex-grid
    #categoryRateGrid
    style="height: 360px"
    [isReadOnly]="true"
    (initialized)="categoryGrid.initialize(categoryRateGrid)"
    (destroy)="categoryGrid.destroy()"
    [itemsSource]="categoryGrid.view"
>
    <wj-flex-grid-filter></wj-flex-grid-filter>
    <wj-flex-grid-column [header]="'Category'" [binding]="'name'" [width]="240"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Average Total Rate'" [binding]="'averageRate'" [width]="160" [format]="'c2'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Fuel (300)'" [binding]="'fuelRate'" [width]="120" [format]="'c2'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'M&R (400)'" [binding]="'maintenanceRate'" [width]="120" [format]="'c2'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Purchase (100)'" [binding]="'purchaseRate'" [width]="140" [format]="'c2'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Indirects (200)'" [binding]="'indirectRate'" [width]="140" [format]="'c2'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Hours'" [binding]="'hours'" [width]="100" [format]="'n1'"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Trend'" [binding]="'trend'" [width]="110" [format]="'p1'">
        <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
            @if (cell.item.trend == null) {
                <span></span>
            } @else {
                {{ cell.item.trend > 0 ? '▲' : cell.item.trend < 0 ? '▼' : '' }} {{ cell.item.trend | percent: '1.1-1' }}
            }
        </ng-template>
    </wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Adjusted Fuel (300)'" [binding]="'adjustedFuel'" [width]="170" [format]="'c2'" [visible]="hasFuelPrice"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Adjusted Total Rate'" [binding]="'adjustedTotal'" [width]="170" [format]="'c2'" [visible]="hasFuelPrice"></wj-flex-grid-column>
</wj-flex-grid>
<grid-selection-calculation [grid]="categoryRateGrid"></grid-selection-calculation>

@if (trendSeries.length > 0) {
    <wj-flex-chart
        style="height: 320px"
        class="mt-3"
        [itemsSource]="trendPoints"
        [bindingX]="'year'"
        [chartType]="'Line'"
        [header]="'Rate Trend by Category'"
        [legendToggle]="true"
    >
        <wj-flex-chart-legend [position]="'Bottom'"></wj-flex-chart-legend>
        <wj-flex-chart-axis [wjProperty]="'axisY'" [title]="'$ / hour'" [format]="'c2'" [min]="0"></wj-flex-chart-axis>
        @for (series of trendSeries; track series.binding) {
            <wj-flex-chart-series [binding]="series.binding" [name]="series.name"></wj-flex-chart-series>
        }
    </wj-flex-chart>
    <p class="text-muted small mb-0">Trend is the change in total rate from the first year in the selection to the last. The chart is the yearly total rate, not the fuel-price adjustment.</p>
}

<h5 class="mt-4 mb-1">Category / Equipment</h5>
<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="grid"></action-toolbar-count>
            <action-toolbar-search name="equipmentSearch" [(ngModel)]="grid.filter"></action-toolbar-search>
            <grid-export [grid]="equipmentGrid" [name]="'Equipment Rates'"></grid-export>
        </form>
    </div>
</div>
<p class="text-muted mb-2">
    Drill down from the mega category to the category to the unit. A unit with cost and no hours stays in the cost and shows a blank rate.
</p>

<div class="row">
    <div class="col-xl-7">
        <wj-flex-grid
            id="equipmentGrid"
            #equipmentGrid
            style="height: 640px"
            [isReadOnly]="true"
            [frozenColumns]="4"
            [childItemsPath]="'children'"
            (initialized)="grid.initialize(equipmentGrid)"
            (destroy)="grid.destroy()"
            (selectionChanged)="onGridSelection()"
            [itemsSource]="grid.view"
        >
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Category / Equipment'" [binding]="'name'" [width]="280"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Avg Rate'" [binding]="'avgRate'" [width]="110" [format]="'c2'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Avg Hours'" [binding]="'avgHours'" [width]="110" [format]="'n1'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Avg Cost'" [binding]="'avgCost'" [width]="130" [format]="'c2'"></wj-flex-grid-column>
            @for (year of years; track year) {
                <wj-flex-grid-column [header]="year + ' Rate'" [binding]="'rate' + year" [width]="110" [format]="'c2'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="year + ' Hours'" [binding]="'hours' + year" [width]="110" [format]="'n1'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="year + ' Cost'" [binding]="'cost' + year" [width]="130" [format]="'c2'"></wj-flex-grid-column>
            }
        </wj-flex-grid>
        <grid-selection-calculation [grid]="equipmentGrid"></grid-selection-calculation>
    </div>
    <div class="col-xl-5">
        @if (selected) {
            <h5 class="mb-2">{{ selected.name }}</h5>
            <div class="table-responsive">
                <table class="table table-sm table-bordered mb-2">
                    <thead>
                        <tr>
                            <th>Rate</th>
                            <th class="text-end">Avg</th>
                            @for (year of selected.years; track year.year) {
                                <th class="text-end">{{ year.year }}</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (line of breakdownLines; track line.label) {
                            <tr [class.fw-bold]="line.bold">
                                <td [class.ps-4]="line.indent">{{ line.label }}</td>
                                <td class="text-end">
                                    @if (line.average != null) {
                                        {{ line.average | currency }}
                                    }
                                </td>
                                @for (value of line.values; track $index) {
                                    <td class="text-end">
                                        @if (value != null) {
                                            {{ value | currency }}
                                        }
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
                <table class="table table-sm table-bordered mb-0">
                    <thead>
                        <tr>
                            <th></th>
                            <th class="text-end">Avg</th>
                            @for (year of selected.years; track year.year) {
                                <th class="text-end">{{ year.year }}</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (line of supportLines; track line.label) {
                            <tr>
                                <td>{{ line.label }}</td>
                                <td class="text-end">
                                    @if (line.average != null) {
                                        @if (line.kind === 'hours') {
                                            {{ line.average | number: '1.0-1' }}
                                        } @else {
                                            {{ line.average | currency }}
                                        }
                                    }
                                </td>
                                @for (value of line.values; track $index) {
                                    <td class="text-end">
                                        @if (value != null) {
                                            @if (line.kind === 'hours') {
                                                {{ value | number: '1.0-1' }}
                                            } @else {
                                                {{ value | currency }}
                                            }
                                        }
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            <p class="text-muted small mt-2 mb-0">Rates are dollars per revenue hour. Hours and cost are the totals behind those rates.</p>
        } @else {
            <p class="text-muted">Select a group, category, or unit to see the rate breakdown.</p>
        }
    </div>
</div>
